<script>
    import { getTopAreaHeight } from "../../utils/utils";

    export default {
        data() {
            return {
                isGated: false,
                formHeight: 0,
                actualHeight: 0,
                isExtended: false,
                selected: {},
                formLoading: false,
                formIsLoaded: false
            };
        },
        mounted() {
            this.$el.addEventListener("do-attachment-gating", this.doGating);
            this.$el.addEventListener("remove-attachment-gating", this.removeGating);
        },
        methods: {
            doGating() {
                this.isGated = true;
            },
            removeGating() {
                if (this.selected.href && this.$refs.gatedBtn) {
                    this.$refs.gatedBtn.href = this.selected.href;
                    const successLink = this.$el.querySelector(".success-download-link");
                    if (successLink) {
                        successLink.href = this.selected.href;
                    }
                }
                this.isGated = false;
            },
            multipleAttachmentBtnClick(e) {
                e.preventDefault();
                if (this.selected.href) {
                    this.loadAttachmentForm();
                }
            },
            singleAttachmentBtnClick(e) {
                e.preventDefault();
                this.loadAttachmentForm();
            },
            imageBannerBtnClick(e) {
                e.preventDefault();
                this.loadForm();
            },
            imageBannerLinkClick(e) {
                const link = e.target.getAttribute("href");
                const hash = link && link.split("#")[1];
                if (hash) {
                    const $form = $("#" + hash);
                    if ($form.length) {
                        e.preventDefault();
                        if (typeof inquiry_verticalBtnFn === "function") {
                            inquiry_verticalBtnFn(hash, $form.parent().attr("id"));
                        } else {
                            const headerHeight = 69;
                            window.scrollTo({ top: $form.offset().top - headerHeight, behavior: "smooth" });
                        }
                    }
                }
            },
            loadAttachmentForm() {
                if (!this.formIsLoaded) {
                    this.loadForm();
                } else {
                    this.expandOrCollapseForm();
                }
            },
            loadForm() {
                this.formLoading = true;
                const iframe = $(this.$el).parent().find("iframe");
                iframe.attr("src", iframe.data("src"));
                iframe.on("load", () => {
                    this.formLoading = false;
                    this.formIsLoaded = true;
                    this.doGating();
                    if (!this.isExtended) {
                        this.expandOrCollapseForm();
                    }
                });
            },
            expandOrCollapseForm(e) {
                if (!this.isGated) return;
                e && e.preventDefault();

                const transitionLength = 500;
                const parent = $(this.$el).parent();
                const extendableForm = parent.find(".extendableForm");

                let formHeight = extendableForm.find(".iframe-form-block__content").outerHeight() +
                    extendableForm.find(".extendableForm__title").outerHeight();

                if (parent.hasClass("extended")) {
                    collapse.call(this);
                } else {
                    expand.call(this);
                }

                function expand() {
                    parent.addClass("extended");
                    extendableForm.height(formHeight + "px");
                    extendableForm.addClass("expanding");
                    setTimeout(() => {
                        extendableForm.removeClass("expanding");
                        extendableForm.addClass("extended").attr('tabindex', '0').focus();
                        extendableForm.height("");
                        extendableForm.find("button").on("click", collapse.bind(this));
                        extendableForm.on("keyup", (e) => {
                            if (e.originalEvent && e.originalEvent.keyCode === 27) {
                                extendableForm.find("button").click();
                            }
                        });
                        $("html, body").stop().animate(
                            { scrollTop: extendableForm.offset().top - getTopAreaHeight() },
                            transitionLength,
                            "swing"
                        );
                    }, transitionLength);
                    this.isExtended = true;
                }

                function collapse() {
                    formHeight = extendableForm.find(".extendableForm__content").outerHeight() +
                        extendableForm.find(".extendableForm__title").outerHeight();
                    parent.removeClass("extended");
                    extendableForm.height(formHeight);
                    extendableForm.height(0);
                    extendableForm.find("svg").off("click", collapse.bind(this));
                    extendableForm.addClass("collapsing");
                    extendableForm.off("keyup");
                    setTimeout(() => {
                        extendableForm.removeClass("collapsing");
                        extendableForm.removeClass("extended").attr('tabindex', '-1');
                        $("html, body").stop().animate(
                            { scrollTop: parent.offset().top - getTopAreaHeight() },
                            transitionLength,
                            "swing"
                        );
                    }, transitionLength);
                    this.isExtended = false;
                }
            }
        }
    };
</script>